module.exports = __webpack_public_path__ + "static/media/akkurat-mono-webfont.d70c0882.otf";